export function addMaskCpf(cpf) {
    if (!cpf) return cpf;

    return cpf.toString().replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function addMaskCnpj(cpf) {
    if (!cpf) return cpf;

    return cpf.toString().replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

export function addMaskSus(sus) {
    if (!sus) return sus;

    return sus.toString().replace(/(\d{3})(\d{4})(\d{4})(\d{4})/, '$1 $2 $3 $4');
}

export function addMaskPis(pis) {
    if (!pis) return pis;

    return pis.toString().replace(/(\d{3})(\d{5})(\d{2})(\d{1})/, '$1.$2.$3-$4');
}

export function addMaskCellphone(cellphone) {
    if (!cellphone) return cellphone;

    return cellphone.toString().replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
}

export function addMaskPhone(phone) {
    if (!phone) return phone;

    return phone.toString().replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
}

export function addMaskCep(cep) {
    if (!cep) return cep;

    return cep.toString().replace(/(\d{5})(\d{3})/, '$1-$2');
}

export function formatMoney(value, config = {}) {
    const formattedValue = Number.isNaN(+value) ? 0 : +value
    return formattedValue.toLocaleString(config.locale || 'pt-BR', { style: 'currency', currency: 'BRL', ...config });
}

export function formatISOToDateString(iso) {
    const date = new Date(iso);
    const year = date.getFullYear();
    let month = date.getMonth()+1;
    let dt = date.getDate();

    if (dt < 10) {
        dt = `0${dt}`;
    }
    if (month < 10) {
        month = `0${month}`;
    }

    return `${dt}/${month}/${year}`;
}